import { render, staticRenderFns } from "./ListCreditosUsuario.vue?vue&type=template&id=48945efb&"
import script from "./ListCreditosUsuario.vue?vue&type=script&lang=js&"
export * from "./ListCreditosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ListCreditosUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports